
import { ReactComponent as ScrolldownIcon } from '../assets/icons/scrolldown.svg';
import { ReactComponent as ArrowDown } from '../assets/icons/chevron-arrow.svg';
export default function Spinner() {
    return <a className='hidden group lg:block absolute -bottom-[100px] left-[3%]'>
        <ArrowDown className='absolute block left-[50%] top-[50%] -translate-y-[50%] group-hover:opacity-70 w-4 h-4 -translate-x-[50%] transition-all duration-300' />
        <ScrolldownIcon className='button__hover__difference w-[250px] h-[250px] group-hover:opacity-70 transition-all duration-300' id="spinner" />
    </a>
}